import "./SimpleModal.css";
import React, { Component } from 'react';
import { Modal, ModalBody } from 'react-modal-bootstrap';

export default class SimpleModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.isOpen || false
    };
    this.hideModal = this.hideModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({ isOpen: this.props.isOpen });
    }
  }

  hideModal() {
    this.setState({ isOpen: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    return (
      <Modal isOpen={this.state.isOpen} onRequestHide={this.hideModal}>
        <button
          type="button"
          className={"modalCloseButton"}
          onClick={this.hideModal}
          aria-label="close"
        >
        </button>
          {this.props.content}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/SimpleModal/SimpleModal.js